import { useQuery } from '@tanstack/react-query';
import { listPrincipals } from './index';

// Global to the logged-in user (who they may act as) — NOT principal-scoped, so
// this key is deliberately plain (no withPrincipal).
export const K_PRINCIPALS = 'K_PRINCIPALS';

export const useListPrincipals = () =>
  useQuery({
    queryKey: [K_PRINCIPALS],
    queryFn: listPrincipals,
    staleTime: 5 * 60 * 1000,
  });
